import { useMemo } from "react";
import debounce from "lodash/debounce";
import { useGlobalPrivateChannelListener } from "~/components/Hooks/useGlobalPrivateChannelListener";

export function useTaskSplitsRealTime(refetch) {
  const debouncedRefetch = useMemo(() => debounce(refetch, 2000), [refetch]);
  useGlobalPrivateChannelListener("TaskEstimateSplit", debouncedRefetch);
  useGlobalPrivateChannelListener("TaskEstimateSplitsUpdated", debouncedRefetch);
  useGlobalPrivateChannelListener("TaskEstimateUnsplit", debouncedRefetch);
}
